<template>
  <div class="landing-wrapper">
    <!-- Navigation -->
    <LandingNavbar
      :mobile-menu-open="navigation.mobileMenuOpen"
      :active-dropdown="navigation.activeDropdown"
      :is-scrolled="navigation.isScrolled"
      @toggle-mobile-menu="toggleMobileMenu"
      @toggle-dropdown="toggleDropdown"
      @scroll-to-section="scrollToSection"
    />

    <!-- Page Content -->
    <slot />

    <!-- Footer -->
    <LandingFooter />

    <!-- Back to Top Button -->
    <transition name="fade">
      <button
        v-show="showBackToTop"
        class="back-to-top-btn"
        @click="scrollToTop"
      >
        <i class="fas fa-chevron-up" />
      </button>
    </transition>
  </div>
</template>

<script>
import LandingNavbar from '@/components/landing/LandingNavbar.vue'
import LandingFooter from '@/components/landing/LandingFooter.vue'
import { MxLandingNavigation } from '@/mixins/landing'

export default {
  name: 'LandingHeader',

  components: {
    LandingNavbar,
    LandingFooter
  },

  mixins: [MxLandingNavigation],

  data () {
    return {
      showBackToTop: false
    }
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
      this.navigation.isScrolled = window.scrollY > 50
    },

    handleClickOutside (event) {
      if (!event.target.closest('.dropdown')) {
        this.navigation.activeDropdown = null
      }
    },

    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/landing/layout/header.css';
</style>
